import React from 'react'

import { useConfirmationModal } from 'hooks'
import { checkActiveModule } from 'utils/modules'
import { useMoveResourceModalForm } from './common/MoveResourceForm/hooks'

export const useMoveResourceModalState = (state, handlers) => {
  const { position } = state
  const { onCancel, onClose, onConfirm } = handlers

  const hasInterviewModule = checkActiveModule(position?.modules?.interview)

  const {
    state: { control, formState, isDirtyOrInvalid },
    handlers: { handleFormReset, handleFormSubmit },
  } = useMoveResourceModalForm({ position, hasInterviewModule }, { onConfirm })

  const {
    handleConfirmationClose,
    handleConfirmationConfirm,
    handleConfirmationOpen,
    isConfirmationOpen,
  } = useConfirmationModal(() => {
    handleFormReset()
    onClose()
  })

  const handleCancel = React.useCallback(() => {
    isDirtyOrInvalid ? handleConfirmationOpen() : onCancel()
  }, [isDirtyOrInvalid, handleConfirmationOpen, onCancel])

  const handleClose = React.useCallback(() => {
    isDirtyOrInvalid ? handleConfirmationOpen() : onClose()
  }, [isDirtyOrInvalid, handleConfirmationOpen, onClose])

  const handleConfirm = React.useCallback(handleFormSubmit, [handleFormSubmit])

  return {
    state: {
      form: { control, formState },
      hasInterviewModule,
      isConfirmationOpen,
    },
    handlers: {
      handleCancel,
      handleClose,
      handleConfirm,
      handleConfirmationClose,
      handleConfirmationConfirm,
    },
  }
}
